// With this approach we do not need any changes to tsconfigs or webpack configs
// If ever the sw folder changes we need to change the path here too.
import { ONE_SECOND } from '@lucidlink/uicore';
// Time to activation might be a bit slow on the first file download as browser
// has to download the service worker js file.
const DEFAULT_WAIT_TIME_FOR_ACTIVATION = 15 * ONE_SECOND;
const ACTIVE_WORKER_POLL_INTERVAL = 50;
// Firefox can run the SW's 'activate' handler (which sends the activation
// broadcast) before it populates registration.active on the page side.
const waitForActiveWorker = async (serviceWorkerRegistration, timeLimit) => {
    const deadline = Date.now() + timeLimit;
    while (!serviceWorkerRegistration.active) {
        if (Date.now() >= deadline) {
            // TODO: throw a custom error type
            throw new Error('Service Worker registration did not expose an active worker in time');
        }
        await new Promise((resolve) => {
            setTimeout(resolve, ACTIVE_WORKER_POLL_INTERVAL);
        });
    }
};
export const startSWAndWaitOnActivate = async ({ activationPromise, scope, throwAfter = DEFAULT_WAIT_TIME_FOR_ACTIVATION, }) => {
    let throwTimeout;
    let serviceWorkerRegistration;
    // eslint-disable-next-line no-useless-catch -- Not useless, will rethrow different error type
    try {
        serviceWorkerRegistration = await navigator.serviceWorker.register(
        // Follow the requirements for this type of URL to work - https://webpack.js.org/guides/web-workers/
        // Do not save the URL into a const, do not save 'navigator.serviceWorker' in a const
        new URL('../../service-worker/file-download-sw.ts', import.meta.url), { scope });
    }
    catch (error) {
        // TODO: throw a custom error type
        throw error;
    }
    return Promise.race([
        new Promise((_, reject) => {
            throwTimeout = window.setTimeout(() => {
                // TODO: throw a custom error type
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- preserve the existing string rejection (behavior-neutral migration); no caller inspects an Error type here
                reject('Service Worker did not respond in time');
            }, throwAfter);
        }),
        (async () => {
            await activationPromise;
            await waitForActiveWorker(serviceWorkerRegistration, throwAfter);
            clearTimeout(throwTimeout);
            return serviceWorkerRegistration;
        })(),
    ]);
};
